(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/primary-onboarding/assets/javascripts/hint-item.js') >= 0) return;  svs.modules.push('/templates/primary-onboarding/assets/javascripts/hint-item.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const verifyObject = svs.components.lbUtils.verify.verifyObject;
const logger = svs.components.lbUtils.onboarding.log;
const _svs$templates$primar = svs.templates.primaryOnboarding.constants,
  hintVerifyType = _svs$templates$primar.hintVerifyType,
  HintVisibility = _svs$templates$primar.HintVisibility,
  hintLogicFields = _svs$templates$primar.hintLogicFields,
  baseHintItem = _svs$templates$primar.baseHintItem;
const checkChanges = svs.templates.primaryOnboarding.utils.checkChanges;
const setOnboardingInfo = svs.templates.primaryOnboarding.onboardingInfo.setOnboardingInfo;
const _svs$templates$primar2 = svs.templates.primaryOnboarding.sessionStorage,
  setItem = _svs$templates$primar2.setItem,
  getItem = _svs$templates$primar2.getItem;

const knownHintKeysKey = 'knownHintKeys';
const knownHints = getItem(knownHintKeysKey) || [];
const writeHintToSession = hint => {
  if (!knownHints.includes(hint.key)) {
    knownHints.push(hint.key);
    setItem(knownHintKeysKey, knownHints);
  }
  setItem(hint.key, {
    hasTriggered: hint.hasTriggered
  });
};
const getHintFromSession = key => getItem(key);
const setHintToOnboardingInfo = hint => {
  try {
    verifyObject(hint).schema(hintVerifyType);
    writeHintToSession(hint);
    setOnboardingInfo(hint.key, hint);
  } catch (err) {
    logger.debug('Failed to set hint to onboarding info', err);
  }
};
const createHintItem = props => {
  for (const key in props) {
    if (!(key in baseHintItem)) {
      delete props[key];
    }
  }
  const sessionHint = getHintFromSession(props.key) || {};
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, baseHintItem), props), hintLogicFields), sessionHint);
};
const addNewHint = hint => {
  try {
    const hintItem = createHintItem(hint);
    verifyObject(hintItem).schema(hintVerifyType);
    const _ref = getHintFromSession(hintItem.key) || {
        hasTriggered: hintItem.hasTriggered
      },
      hasTriggered = _ref.hasTriggered;
    setHintToOnboardingInfo(_objectSpread(_objectSpread({}, hintItem), {}, {
      hasTriggered
    }));
  } catch (err) {
    logger.debug('Failed to add new hint', err);
  }
};
let hintHooks = {};
const registerHintHooks = hooks => {
  hintHooks = _objectSpread(_objectSpread({}, hintHooks), hooks);
};
const triggerHintHooks = (oldHint, newHint) => {
  const changes = checkChanges(oldHint, newHint);
  if (changes.size > 0) {
    changes.forEach((_ref2, key) => {
      let oldValue = _ref2.oldValue,
        newValue = _ref2.newValue;
      if (hintHooks[key]) {
        hintHooks[key](oldValue, newValue, oldHint, newHint);
      }
    });
  }
};
const updateHintWithChanges = (hint, changes) => {
  const newHint = _objectSpread(_objectSpread({}, hint), changes);
  const changesKeys = Object.keys(changes);
  if (changesKeys.includes('isVisible') || changesKeys.includes('isAvailable')) {
    if (newHint.isVisible && newHint.isAvailable) {
      newHint.visibility = HintVisibility.Visible;
    } else if (newHint.isAvailable) {
      newHint.visibility = HintVisibility.Available;
    } else {
      newHint.visibility = HintVisibility.None;
    }
  }
  setHintToOnboardingInfo(newHint);
  triggerHintHooks(hint, newHint);
};

setGlobal('svs.templates.primaryOnboarding.hintItem', {
  addNewHint,
  updateHintWithChanges,
  registerHintHooks
});

 })(window);